<template>
    <DefaultLayout :title="__('admin::disallowed-dates.disallowed_dates')">

        <template #title>
            <InertiaLink :href="$route('admin::disallowed-dates.edit')">{{ __('admin::disallowed-dates.disallowed_dates') }}</InertiaLink>
        </template>

        <template #default>

            <div class="py-6">
                <div class="mx-auto px-4 sm:px-6 md:px-8">

                    <Panel>

                        <form @submit.prevent="submit">

                            <OpenHouseDisallowedDates v-model="form.dates" />

                            <Button :loading="form.processing" class="mt-6">
                                {{ __('admin::general.update_model', {'model': __('admin::disallowed-dates.disallowed_dates').toLowerCase() }) }}
                            </Button>

                        </form>

                    </Panel>

                </div>
            </div>

        </template>

    </DefaultLayout>
</template>

<script>
    import DefaultLayout from '@/Layouts/DefaultLayout'
    import Panel from "@/Components/Panel";
    import Button from "@/Components/Button";
    import OpenHouseDisallowedDates from "@/Components/OpenHouseDisallowedDates";

    export default {
        components: {
            OpenHouseDisallowedDates,
            Button,
            Panel,
            DefaultLayout,
        },
        props: {
            errors: Object,
            disallowedDates: Object,
        },
        data() {
            return {
                form: this.$inertia.form({
                    dates: Object.values(this.disallowedDates.map((x) => x.date)),
                })
            }
        },
        methods: {
            submit() {
                this.form
                    .transform((data) => ({
                        ...data,
                        _method: 'patch',
                    }))
                    .post(this.$route('admin::disallowed-dates.edit'));
            }
        },
    }
</script>
